import { useState, useEffect } from "react";
import { WithContext as ReactTags, Tag } from "react-tag-input";

const KeyCodes = {
  TAB: 9,
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter, KeyCodes.TAB];

interface Props {
  placeholder?: string;
  value: Tag[];
  suggestions?: Tag[];
  helperText?: string;
  onChange: (data: any) => void;
}

const TagTextInput = ({
  placeholder = "Escriba aquí",
  value,
  suggestions = [],
  helperText = "",
  onChange,
}: Props) => {
  const [tags, setTags] = useState<Tag[]>([]);

  useEffect(() => setTags(value), [value]);

  const handleDelete = (i: number) => {
    const data = tags.filter((_: any, index: number) => index !== i);
    setTags(data);
    onChange(data);
  };

  const handleAddition = (tag: any) => {
    const data = [...tags, tag];
    setTags(data);
    onChange(data);
  };

  const handleDrag = (tag: any, currPos: number, newPos: number) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleTagClick = (index: number) => {
    //console.log('The tag at index ' + index + ' was clicked');
  };

  return (
    <div>
      <ReactTags
        tags={tags}
        suggestions={suggestions.length > 0 ? suggestions : []}
        delimiters={delimiters}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        handleDrag={handleDrag}
        handleTagClick={handleTagClick}
        inputFieldPosition="top"
        placeholder={placeholder}
        autofocus={false}
        autocomplete
        classNames={{
          tags: "w-full",
          tagInput: "w-full",
          tagInputField:
            "block w-full border disabled:cursor-not-allowed disabled:opacity-50 border-gray-300 bg-gray-50 text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500 p-2.5 text-sm rounded-lg mb-2",
          tag: "h-fit mr-1 items-center gap-1 font-semibold bg-gray-100 text-cyan-800 group-hover:bg-cyan-200 dark:bg-cyan-200 dark:text-cyan-800 dark:group-hover:bg-cyan-300 text-xs rounded-full p-1.5",
          remove: "ml-1",
        }}
      />
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        {helperText}
      </p>
    </div>
  );
};

export default TagTextInput;
